<template>
    <!--
    <div class="mt-2">
        <div class="grid grid-cols-4 gap-1">
            <div class="text-center">
                <svg-icon type="mdi" :path="isOnline ? mdiCheckCircle : mdiCloseCircle" 
                         :class="isOnline ? 'text-success' : 'text-error'" size="12"/>
                <div class="text-xs font-medium">{{ isOnline ? 'ON' : 'OFF' }}</div>
            </div>
            <div class="text-center">
                <svg-icon type="mdi" :path="mdiBattery" :class="batteryColor" size="12"/>
                <div class="text-xs font-medium" :class="batteryColor">{{ batteryLevel }}%</div>
            </div>
            <div class="text-center">
                <svg-icon type="mdi" :path="mdiArrowUp" class="text-blue-500" size="12"/>
                <div class="text-xs">{{ altitude }}m</div>
            </div>
            <div class="text-center">
                <svg-icon type="mdi" :path="mdiSpeedometer" class="text-green-500" size="12"/>
                <div class="text-xs">{{ speed }}</div>
            </div>
        </div>
    </div>
    -->
    <div class="flex flex-auto w-full bg-base-100 text-xs rounded-sm px-1">

        <span class="rounded-sm bg-base-300 px-1 mx-1 flex items-center group relative">
            <span>{{ altitude + "m" }} </span>
            <span
                class="absolute bottom-full left-translate-x-1/2 mb-1 px-2  py-1 rounded bg-black text-white text-xs whitespace-nowrap opacity-0 group-hover:opacity-100 pointer-events-none transition-opacity duration-200">
                Altitud
            </span>
        </span>

        <span class="rounded-sm bg-base-300 px-1 mx-1 flex items-center group relative">
            <svg-icon type="mdi" :path="mdiMapMarkerDistance" size="12" class="mr-1" />
            <span>{{ homeDistance }} </span>
            <span
                class="absolute bottom-full left-translate-x-1/2 mb-1 px-2  py-1 rounded bg-black text-white text-xs whitespace-nowrap opacity-0 group-hover:opacity-100 pointer-events-none transition-opacity duration-200">
                Distancia al Dock 
            </span>
        </span>

        <span class="rounded-sm bg-base-300 px-1 mx-1 flex items-center group relative">
            <svg-icon type="mdi" :path="mdiBatteryArrowDown" size="12" class="mr-1" />
            <span>{{ droneBattery }}</span>
            <span
                class="absolute bottom-full left-translate-x-1/2 mb-1 px-2  py-1 rounded bg-black text-white text-xs whitespace-nowrap opacity-0 group-hover:opacity-100 pointer-events-none transition-opacity duration-200">
                Bateria del dron
            </span>
        </span>

        <span class="rounded-sm bg-base-300 px-1 mx-1 flex items-center group relative">
            <svg-icon type="mdi" :path="mdiWeatherWindy" size="12" class="mr-1" />
            <span>{{ windSpeed }}</span>
            <span
                class="absolute bottom-full left-translate-x-1/2 mb-1 px-2  py-1 rounded bg-black text-white text-xs whitespace-nowrap opacity-0 group-hover:opacity-100 pointer-events-none transition-opacity duration-200">
                Velocidad del viento
            </span>
        </span>

    </div>
</template>

<script setup>
/* eslint-disable */
import { computed, onMounted } from 'vue'
import SvgIcon from '@jamescoyle/vue-icon'
import {
    mdiMapMarkerDistance,
    mdiBatteryArrowDown,
    mdiWeatherWindy
} from '@mdi/js'

const props = defineProps({
    telemetry: {
        type: Object,
        default: () => ({})
    },
    isOnline: {
        type: Boolean,
        default: false
    }
})

onMounted(() => {
    console.log(props.telemetry)
})


const droneBattery = computed(() => {
    return props.telemetry["battery.capacity_percent"] || "N/A"
})

const altitude = computed(() => {
    return Math.floor(props.telemetry.elevation) || 0
})

const homeDistance = computed(() => {
    return Math.floor(props.telemetry["home_distance"]/100)/10 + "km" || "N/A"
})

const windSpeed = computed(() => {
    return props.telemetry.wind_speed/10 || "N/A"
})
</script>